import React, { useEffect, useState, useRef } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import MaterialTable from "material-table";
import { baseURL, headers } from "../../../../../global/api";
import { deleteRestaurant, updateRestaurant } from "./Resturant.action";
import { setHeading } from "../../../accounts/account.actions";
import ShareIcon from '@mui/icons-material/Share';
import QrCodeIcon from '@mui/icons-material/QrCode';
import { showSuccessAlert } from "../../../../../global/globalFunctions";
import QRCode from "qrcode";



const styles = {
  overlay: {
    position: "fixed", inset: 0,
    background: "rgba(10,12,20,0.72)",
    backdropFilter: "blur(6px)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 9999,
    animation: "fadeIn .2s ease",
  },
  card: {
    background: "#0f1117",
    border: "1px solid rgba(0,187,187,0.18)",
    borderRadius: 20,
    padding: "36px 32px 28px",
    width: 360,
    boxShadow: "0 0 60px rgba(0,187,187,0.12), 0 24px 48px rgba(0,0,0,0.6)",
    position: "relative",
    animation: "slideUp .25s cubic-bezier(.22,1,.36,1)",
  },
  closeBtn: {
    position: "absolute", top: 14, right: 18,
    background: "none", border: "none",
    color: "#6b7280", fontSize: 22, cursor: "pointer",
    lineHeight: 1, padding: 4, borderRadius: 6,
    transition: "color .15s",
  },
  title: {
    fontFamily: "'Syne', sans-serif",
    fontSize: 18, fontWeight: 700,
    color: "#e2e8f0", margin: "0 0 4px",
    letterSpacing: "-0.3px",
  },
  subtitle: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 12, color: "#6b7280", margin: "0 0 24px",
  },
  canvasWrap: {
    background: "#fff",
    borderRadius: 14,
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: 16,
    margin: "0 auto 24px",
    width: 220, height: 220,
    boxShadow: "0 0 0 1px rgba(0,187,187,0.2), 0 8px 32px rgba(0,0,0,0.4)",
  },
  btn: {
    display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
    width: "100%", padding: "11px 0",
    borderRadius: 10, border: "none",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 14, fontWeight: 600,
    cursor: "pointer", transition: "all .18s",
  },
  btnPrimary: {
    background: "linear-gradient(135deg,#00BBBB,#0088cc)",
    color: "#fff",
    boxShadow: "0 4px 16px rgba(0,187,187,0.3)",
  },
  btnSecondary: {
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.1)",
    color: "#cbd5e1",
  },
  divider: {
    display: "grid", gridTemplateColumns: "1fr auto 1fr",
    alignItems: "center", gap: 10,
    margin: "12px 0",
    color: "#374151", fontSize: 11,
    fontFamily: "'DM Sans', sans-serif",
  },
  divLine: { height: 1, background: "rgba(255,255,255,0.08)" },
};
const injectKeyframes = () => {
  if (document.getElementById("qr-modal-kf")) return;
  const s = document.createElement("style");
  s.id = "qr-modal-kf";
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700&family=DM+Sans:wght@400;600&display=swap');
    @keyframes fadeIn  { from{opacity:0}   to{opacity:1} }
    @keyframes slideUp { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:none} }
  `;
  document.head.appendChild(s);
};
const QRModal = ({ company, onClose }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    injectKeyframes();
    if (!company) return;
    const url = `${window.location.origin}/company/${company.restaurantName}`;
    QRCode.toCanvas(canvasRef.current, url, {
      width: 188,
      margin: 0,
      color: { dark: "#0f1117", light: "#ffffff" },
    });
  }, [company]);

  const getDataURL = () =>
    canvasRef.current?.toDataURL("image/png");

  const handleDownload = () => {
    const dataURL = getDataURL();
    if (!dataURL) return;
    const a = document.createElement("a");
    a.href = dataURL;
    a.download = `${company.restaurantName}-qr.png`;
    a.click();
    showSuccessAlert("QR Code downloaded!");
  };

  const handleShare = async () => {
    const url = `${window.location.origin}/company/${company.restaurantName}`;
    if (navigator.share) {
      try {
        const blob = await (await fetch(getDataURL())).blob();
        const file = new File([blob], `${company.restaurantName}-qr.png`, { type: "image/png" });
        await navigator.share({
          title: company.restaurantName,
          text: `Scan to view ${company.restaurantName}`,
          url,
          files: navigator.canShare?.({ files: [file] }) ? [file] : undefined,
        });
      } catch {
        // fallback: copy link
        navigator.clipboard.writeText(url);
        showSuccessAlert("Link copied to clipboard!");
      }
    } else {
      navigator.clipboard.writeText(url);
      showSuccessAlert("Link copied to clipboard!");
    }
  };

  if (!company) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.card} onClick={(e) => e.stopPropagation()}>
        <button
          style={styles.closeBtn}
          onClick={onClose}
          onMouseEnter={(e) => (e.target.style.color = "#e2e8f0")}
          onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
        >
          ×
        </button>

        <p style={styles.title}>QR Code</p>
        <p style={styles.subtitle}>{company.restaurantName}</p>

        <div style={styles.canvasWrap}>
          <canvas ref={canvasRef} />
        </div>

        {/* Download */}
        <button
          style={{ ...styles.btn, ...styles.btnPrimary }}
          onClick={handleDownload}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.88")}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Download PNG
        </button>

        {/* divider */}
        <div style={styles.divider}>
          <span style={styles.divLine} />
          <span>or</span>
          <span style={styles.divLine} />
        </div>

        {/* Share */}
        <button
          style={{ ...styles.btn, ...styles.btnSecondary }}
          onClick={handleShare}
          onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.1)")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.06)")}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
          </svg>
          Share Link
        </button>
      </div>
    </div>
  );
};


const ViewResturant = (props) => {
  const [qrCompany, setQrCompany] = useState(null);
  const permissions = JSON.parse(window.localStorage.getItem("permissions"));
  const Checkpermissions = (permissionsType, permissionsName) =>
    permissions.some((p) => p[`${permissionsType}`] === permissionsName) ? false : true;

  const handleShare = (rowData) => {
    const link = `${window.location.origin}/company/${rowData.restaurantName}`;
    navigator.clipboard.writeText(link);
    showSuccessAlert("Company link copied!");
  };

  useEffect(() => {
    props.setHeading("Company List");
  }, []);

  return (
    <>
      {qrCompany && (
        <QRModal company={qrCompany} onClose={() => setQrCompany(null)} />
      )}

      <Container fluid>
        <MaterialTable
          title="Company List"
          columns={[
            // { title: 'Restaurant Id', field: 'restaurant_id', editable: 'never' },
            { title: 'Image', field: 'image', editable: 'never', render: rowData => <img src={rowData.image} alt="resImg" style={{ width: 50, borderRadius: '50%' }} /> },
            { title: 'Company Name', field: 'restaurantName' },
            { title: 'Company Location', field: 'restaurantLocation' },
            // { title: 'Description', field: 'restaurantDesc' },
            // { title: 'tax', field: 'tax' },
            { title: 'NTN Number', field: 'ntn' },
            { title: 'Tax Type', field: 'taxType' },
            // { title: 'PRA On Cash', field: 'praTaxCash' },
            // { title: 'PRA On Card', field: 'praTaxCard' },
            // { title: 'FBR On Cash', field: 'fbrTaxCash' },
            // { title: 'FBR On Card', field: 'fbrTaxCard' },
            { title: 'Email', field: 'email' },
            { title: 'Phone', field: 'phone' },
            // { title: 'STRN', field: 'strn' },
          ]}
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky", top: 0,
              color: "#00BBBB", fontWeight: "550",
              onRowAdd: "none", whiteSpace: "nowrap",
            },
            rowStyle: { whiteSpace: "nowrap" },
            cellStyle: {
              whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
            },
          }}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/company/get-companies?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + query.page;
              url += "&search=" + query.search;
              fetch(url, { method: "GET", headers }).then((res) => res.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          editable={{
            isEditHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Company Edit"),
            isDeleteHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Company Delete"),
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => { resolve(); props.updateRestaurant(newData, oldData); }, 600);
              }),
          }}
          actions={[
            {
              icon: () => <ShareIcon />,
              tooltip: "Share Company Link",
              onClick: (event, rowData) => handleShare(rowData),
            },
            {
              icon: () => <QrCodeIcon />,
              tooltip: "Generate QR Code",
              onClick: (event, rowData) => setQrCompany(rowData),
            },
          ]}
        />
      </Container>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  deleteRestaurant: (restaurantId) => dispatch(deleteRestaurant(restaurantId)),
  updateRestaurant: (newData, oldData) => dispatch(updateRestaurant(newData, oldData)),
  setHeading: (data) => dispatch(setHeading(data)),
});

const mapStateToProps = (state, ownProps) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ViewResturant);